function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import StoreFilters from "./storeFilters.class";
import { Constants as CONSTANTS } from "./constants.class";
import Tracking from "./tracking.class";
import Accordion from "@mozaic-ds/freemarker/js/modules/_accordion";
var Filters = /*#__PURE__*/function (_StoreFilters) {
  function Filters(config) {
    var _this;
    _classCallCheck(this, Filters);
    _this = _callSuper(this, Filters, [config]);
    try {
      if (config.event === undefined || config.event === null) throw new Error("Class Filters need event in parameters");
      _this.config = config;
      _this.form = document.querySelector(".".concat(CONSTANTS.FILTER_FORM_SELECTOR.FORM));
      _this.selectedFilters = {};
      if (config.lastSelectedFilter !== undefined && document.getElementById(config.lastSelectedFilter)) {
        _this.lastSelectedFilter = config.lastSelectedFilter;
        document.getElementById(_this.lastSelectedFilter).checked = true;
      }
      if (_this.form) {
        _this.resetFiltersButton = document.querySelector(".".concat(CONSTANTS.FILTER_FORM_SELECTOR.RESET));
        _this.initFilters();
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log("Error class Filters", err);
    }
    return _this;
  }

  /**
   * intialize all events of filters (checkbox , toggle , input etc...)
   */
  _inherits(Filters, _StoreFilters);
  return _createClass(Filters, [{
    key: "initFilters",
    value: function initFilters() {
      _initAccordions.call(this);
      _initCheckboxEvents.call(this);
      _initRadioButtonEvents.call(this);
      _initRangeEvents.call(this);
      _initReviewEvents.call(this);
      _initResetEvent.call(this);
    }
  }]);
}(StoreFilters);
export default Filters;
function _initAccordions() {
  var accordionsNodeList = this.form.querySelectorAll(".js-accordion");
  accordionsNodeList.forEach(function (accordion) {
    try {
      new Accordion(accordion);
    } catch (error) {
      console.error(error);
    }
  });
}

/**
 * initalize event of reset filter on popin in mobile version
 * @private
 */
function _initResetEvent() {
  if (Object.keys(this.selectedFilters).length > 0) {
    this.resetFiltersButton.classList.remove("".concat(CONSTANTS.HIDDEN_CLASS));
    if (this.resetFiltersButton.dataset.event === "false") {
      this.resetFiltersButton.dataset.event = "true";
      this.resetFiltersButton.addEventListener("click", _resetFilters.bind(this), {
        once: true,
        capture: true
      });
    }
  } else if (this.resetFiltersButton) {
    this.resetFiltersButton.classList.add("".concat(CONSTANTS.HIDDEN_CLASS));
    this.resetFiltersButton.dataset.event = "false";
  }
}

/**
 * dispatch event on clicked in button reset filters
 * @private
 */
function _resetFilters(e) {
  e.preventDefault();
  this.selectedFilters = {};
  var params = new URLSearchParams(window.location.search);
  params["delete"]("filters");
  window.history.pushState({}, window.tc_vars.page_name, "".concat(window.location.pathname, "?").concat(params.toString()));
  this.dispatch({
    action: "filter",
    filters: this.format(this.selectedFilters)
  });
}

/**
 * init all events for standard and toggle filters
 * @private
 */
function _initCheckboxEvents() {
  var _this2 = this;
  var _checkBoxInputs = this.form.querySelectorAll("input[type=checkbox][data-category]");
  if (_checkBoxInputs.length > 0) {
    _checkBoxInputs.forEach(function (checkbox) {
      checkbox.addEventListener("change", _transformValues.bind(_this2));
      if (checkbox.checked) {
        _getFiltersValues.call(_this2, checkbox);
      }
    });
  }
}
function _initRadioButtonEvents() {
  var _this3 = this;
  var _radioButtonInputs = this.form.querySelectorAll("input[type=radio][data-category]");
  if (_radioButtonInputs.length > 0) {
    _radioButtonInputs.forEach(function (radioButton) {
      radioButton.addEventListener("change", _transformValues.bind(_this3));
      if (radioButton.checked) {
        _getFiltersValues.call(_this3, radioButton);
      }
    });
  }
}

/**
 * init all events for all range filters
 * @private
 */
function _initRangeEvents() {
  var _this4 = this;
  var _rangeElts = this.form.querySelectorAll("[class*='".concat(CONSTANTS.RANGE_FILTERS.INPUT_SELECTOR, "']"));
  if (_rangeElts.length > 0) {
    var _rangeInputs = Array.from(_rangeElts);
    var _allRangesFilters = _rangeInputs.reduce(function (_inputs, _value) {
      if (!Array.isArray(_inputs)) _inputs = [];
      if (_inputs[_value.dataset.category] === undefined) {
        _inputs[_value.dataset.category] = [];
      }
      _inputs[_value.dataset.category].push(_value);
      return _inputs;
    }, 0);
    var _loop = function _loop() {
      var _allRangesFilters$_ca = _slicedToArray(_allRangesFilters[_category], 4),
        _rangeMinInput = _allRangesFilters$_ca[0],
        _rangeMaxInput = _allRangesFilters$_ca[1],
        _resetRangeButton = _allRangesFilters$_ca[2],
        _submitRangeButton = _allRangesFilters$_ca[3];
      var _defaultMin = parseFloat(_rangeMinInput.getAttribute("min"));
      var _defaultMax = parseFloat(_rangeMaxInput.getAttribute("max"));
      var _minApplied = parseFloat(_rangeMinInput.dataset.minApplied);
      var _maxApplied = parseFloat(_rangeMaxInput.dataset.maxApplied);
      if (parseFloat(_rangeMinInput.value) !== _defaultMin || parseFloat(_rangeMaxInput.value) !== _defaultMax) {
        _this4.selectedFilters[_submitRangeButton.dataset.category] = "".concat(_rangeMinInput.value, "~").concat(_rangeMaxInput.value);
      }
      var _rangeInputsNumber = _allRangesFilters[_category].filter(function (_input) {
        return _input.getAttribute("type") === "number";
      });
      _rangeInputsNumber.map(function (input) {
        input.addEventListener("blur", function (evt) {
          if ((evt.target.value === "" || parseFloat(evt.target.value) < _defaultMin) && evt.target.getAttribute("min") !== null) {
            evt.target.value = _defaultMin !== _minApplied ? _minApplied : _defaultMin;
          }
          if ((evt.target.value === "" || parseFloat(evt.target.value) > _defaultMax) && evt.target.getAttribute("max") !== null) {
            evt.target.value = _defaultMax !== _maxApplied ? _maxApplied : _defaultMax;
          }
          if (parseFloat(evt.target.value) > parseFloat(_rangeMaxInput.value)) {
            evt.target.value = parseFloat(_rangeMaxInput.value) - 1;
          }
          if (parseFloat(evt.target.value) < parseFloat(_rangeMinInput.value)) {
            evt.target.value = parseFloat(_rangeMinInput.value) + 1;
          }
          _enabledSubmitRangeButton(_submitRangeButton, !(parseFloat(_rangeMinInput.value) === _minApplied && parseFloat(_rangeMaxInput.value) === _maxApplied));
        });
        input.addEventListener("input", function (evt) {
          if (parseFloat(evt.target.value) > _defaultMin && parseFloat(evt.target.value) < _defaultMax) {
            _enabledSubmitRangeButton(_submitRangeButton);
          }
        });
      });
      _submitRangeButton.addEventListener("click", _transformValues.bind(_this4));
      _resetRangeButton.addEventListener("click", _resetRange.bind(_this4));
    };
    for (var _category in _allRangesFilters) {
      _loop();
    }
  }
}
function _initReviewEvents() {
  var _this5 = this;
  var _reviewResetButtons = this.form.querySelectorAll("[class*='".concat(CONSTANTS.REVIEW_FILTERS.RESET_SELECTOR, "']"));
  _reviewResetButtons.forEach(function (reviewResetButton) {
    reviewResetButton.addEventListener("click", _resetReview.bind(_this5));
  });
}

/**
 * transform all values of diffrents types of filters
 *  example {code1 : [filter1,filter2,filter3],code2:[filter1etc...]}
 * and dispatch event with all values selected
 * @param evt
 */

function _transformValues(evt) {
  var type = evt.target.dataset.type;
  var specificTypes = [CONSTANTS.FILTERS_TYPES.RANGE, CONSTANTS.FILTERS_TYPES.REVIEW];
  var _typeFilter = specificTypes.includes(type) ? type : CONSTANTS.FILTERS_TYPES.STANDARD;
  try {
    switch (_typeFilter) {
      case CONSTANTS.FILTERS_TYPES.RANGE:
        _transformRangeValues.call(this, evt);
        break;
      case CONSTANTS.FILTERS_TYPES.REVIEW:
        _transformReviewValues.call(this, evt);
        break;
      default:
        _transformStandardValues.call(this, evt);
        break;
    }
    this.dispatch({
      action: "filter",
      params: {
        lastSelectedFilter: this.lastSelectedFilter
      },
      filters: this.format(this.selectedFilters)
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log("Error type not be transformed", err);
  }
}

/**
 * transform all range filters values
 * @param evt
 * @private
 */
//eslint-disable-next-line
function _transformRangeValues(evt) {
  this.lastSelectedFilter = evt.target.dataset.category;
  var _rangeValues = this.form.querySelectorAll("input[type=number][data-category=".concat(this.lastSelectedFilter, "]"));
  this.selectedFilters[evt.target.dataset.category] = "".concat(_rangeValues[0].value, "~").concat(_rangeValues[1].value);
  new Tracking({
    event: evt,
    type: "range"
  });
}

//eslint-disable-next-line
function _transformReviewValues(evt) {
  this.lastSelectedFilter = evt.target.dataset.category;
  this.selectedFilters[evt.target.name] = evt.target.value;
  new Tracking({
    event: evt,
    type: "review"
  });
}

/**
 * transform all standard and toggle filters values
 * @param evt
 * @private
 */
//eslint-disable-next-line
function _transformStandardValues(evt) {
  var _evt$target = evt.target,
    name = _evt$target.name,
    checked = _evt$target.checked,
    value = _evt$target.value;
  var types = [CONSTANTS.FILTERS_TYPES.STANDARD, CONSTANTS.FILTERS_TYPES.IMAGE, CONSTANTS.FILTERS_TYPES.COLOR, CONSTANTS.FILTERS_TYPES.VENDOR, CONSTANTS.FILTERS_TYPES.TOGGLE];
  var lastFilterNameValue = evt.target.dataset.name !== "" ? evt.target.dataset.name : name;
  this.lastSelectedFilter = types.indexOf(evt.target.dataset.type) !== -1 ? lastFilterNameValue : null;
  this.selectedFilters[name] = !Object.prototype.hasOwnProperty.call(this.selectedFilters, name) ? [] : this.selectedFilters[name];
  if (checked) {
    this.selectedFilters[name].push(value);
  } else {
    this.selectedFilters[name] = this.selectedFilters[name].filter(function (item) {
      return item !== value;
    });
  }
  if (this.selectedFilters[name].length === 0) {
    delete this.selectedFilters[name];
  }
  new Tracking({
    event: evt,
    type: "filter"
  });
}

/**
 * get all values of checked filters on relaod page
 * @param element
 * @private
 */
function _getFiltersValues(element) {
  var type = element.dataset.type;
  if (type === CONSTANTS.FILTERS_TYPES.STANDARD || type === CONSTANTS.FILTERS_TYPES.TOGGLE || type === CONSTANTS.FILTERS_TYPES.IMAGE || type === CONSTANTS.FILTERS_TYPES.COLOR || type === CONSTANTS.FILTERS_TYPES.VENDOR || type === CONSTANTS.FILTERS_TYPES.REVIEW) {
    var name = element.name,
      value = element.value;
    this.selectedFilters[name] = !Object.prototype.hasOwnProperty.call(this.selectedFilters, name) ? [] : this.selectedFilters[name];
    if (this.selectedFilters[name].indexOf(value) === -1) {
      this.selectedFilters[name].push(value);
    }
  }
}

/**
 * enable and disable button
 * @param _button
 * @param action
 * @private
 */

function _enabledSubmitRangeButton(_button) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (action) {
    _button.classList.remove("is-disabled");
  } else {
    _button.classList.add("is-disabled");
  }
  _button.disabled = !action;
}

/**
 * reset value of range filters
 * @param evt
 * @private
 */
function _resetRange(evt) {
  evt.preventDefault();
  var _rangeValues = this.form.querySelectorAll("input[type=number][data-category=".concat(evt.target.dataset.category, "]"));
  var _rangeMin = _rangeValues[0];
  var _rangeMax = _rangeValues[1];
  _rangeMin.value = parseFloat(_rangeMin.getAttribute("min"));
  _rangeMax.value = parseFloat(_rangeMax.getAttribute("max"));
  delete this.selectedFilters[evt.target.dataset.category];
  this.dispatch({
    action: "filter",
    lastSelectedFilter: this.lastSelectedFilter,
    filters: this.format(this.selectedFilters)
  });
}
function _resetReview(evt) {
  evt.preventDefault();
  delete this.selectedFilters[evt.target.dataset.category];
  this.dispatch({
    action: "filter",
    lastSelectedFilter: this.lastSelectedFilter,
    filters: this.format(this.selectedFilters)
  });
}